import { Component } from '@angular/core'
import { Router, ActivatedRoute } from '@angular/router'
import { NuclearObservable } from '../../nuclear-observable'
import { BaseComponent } from '../../components/base.component'
import { customerGetters } from '../../stores/customer-store'
import { Account, Customer } from '../../types'
import { CustomerActions } from '../../actions/customer-actions'
import { AnalyticsActions } from '../../actions/analytics-actions'
import { userGetters } from '../../stores/user-store'
import { Title } from '@angular/platform-browser'

@Component({
  selector: 'nc-multipass-plan-page',
  template: `
    <div class="inner-detail-content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-12">
            <multipass-plan-form [customerId]="customerId" (onCreate)="next()"></multipass-plan-form>
          </div>
        </div>
      </div>
    </div>
  `,
})
export class NcMultipassPlanPage extends BaseComponent {
  account: Account;
  customer: Customer;
  customerId: number;
  adminImpersonating: boolean = false;

  constructor( private route: ActivatedRoute,
               private customerActions: CustomerActions,
               private router: Router,
               private titleService: Title,
               private analyticsActions: AnalyticsActions
               ) {
    super()
  }

  ngOnInit(): void {
    this.titleService.setTitle('Sign Up - Plan')
    const routeObs = this.route.params.subscribe(params => {
      this.clearRouteObservers()

      this.customerId = +params['customerId']
      this.customerActions.loadCustomer(this.customerId)

      // Fetch the customer and observe changes
      const custObs = NuclearObservable.from<Customer>(customerGetters.customer(this.customerId), { toJS: true }).subscribe(c => {
        this.customer = c
        if (this.customer && !this.customer.multipass) {
          this.router.navigate(['../', 'plan'], { relativeTo: this.route })
        }
      })
      this.routeObservers.push(custObs)
    })

    const accountObs = NuclearObservable.from<Account>(customerGetters.account, { toJS: true }).subscribe(a => this.account = a)
    const userObs = NuclearObservable.from<Object>(userGetters.user, { toJS: true }).subscribe(user => this.adminImpersonating = user && user['adminImpersonating'])
    this.observers.push(routeObs, accountObs, userObs)
  }

  next(): void {
    this.analyticsActions.selectedPlan()
    if (this.adminImpersonating) {
      let redirect_to = '/admins/home'
      if (this.account) { redirect_to = `/accounts/${this.account.id}` }
      window.location.assign(`/switch_back?flash=Customer has been invited to complete sign up!&redirect_to=${redirect_to}`)
    } else if (this.account && this.account.agency) {
      this.customerActions.loadCustomer(this.customerId)
      this.router.navigate(['/account', 'signup', 'activation'])
    } else {
      this.router.navigate(['../', 'payment'], { relativeTo: this.route })
    }
  }
}
